import React from 'react';
import {LOCAL_DOCUMENTS_PAGE_SIZE_OPTIONS} from "../../../../../models/local-documents.models";
import {Pagination} from "@mui/material";
import {PaginationWrapper} from "../../../../../components/common/TableContainer.styled";
import PageSizeSelector from "../../../../../components/common/PageSizeSelector";
import {
    DocumentsDigitizationFooterWrapper,
    FooterLeft,
    FooterRight,
    StyledPageSizeLabel
} from "./DocumentsDigitizationFooter.styled";
import {useTranslation} from "react-i18next";

interface DocumentsDigitizationFooterProps {
    page: number;
    pageSize: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
}

const DocumentsDigitizationFooter = ({
    page,
    pageSize,
    totalPages,
    onPageChange,
    onPageSizeChange,
}: DocumentsDigitizationFooterProps) => {
    const {t} = useTranslation();

    return (
        <DocumentsDigitizationFooterWrapper>
            <FooterLeft>
                <StyledPageSizeLabel>{t('documentsDigitization.footer.label')}</StyledPageSizeLabel>
                <PageSizeSelector
                    options={LOCAL_DOCUMENTS_PAGE_SIZE_OPTIONS}
                    selectedSize={pageSize}
                    onChange={onPageSizeChange}
                />
            </FooterLeft>

            <FooterRight>
                <PaginationWrapper>
                    <Pagination
                        count={totalPages}
                        page={page + 1}
                        onChange={(_, newPage) => onPageChange(newPage - 1)}
                        shape="rounded"
                        color="primary"
                    />
                </PaginationWrapper>
            </FooterRight>
        </DocumentsDigitizationFooterWrapper>
    );
};

export default DocumentsDigitizationFooter;